import React, { Component } from 'react';
import DescriptiveText from './components/descriptiveText.js';
import CustomerHero from './components/customerHero';
import WebscreenSingle from './components/webscreenSingle';
import WebscreenDouble from './components/webscreenDouble';
import WebscreenMobile from './components/webscreenMobile';
import Footer from "./components/footer";

export default class Hosports extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			animations: []
  		};
  }
  componentDidMount() {
  }
  render() {
    return (
      <div>
        <CustomerHero company="Hosports"
          title="A leading force in the watersports industry"
          video=""
          backgroundImage="images/hosports-hero.jpg"
          overlayColor="#c83446"
        />
        <div className="white-background large-margin-top">
          <DescriptiveText
              title="Company Overview"
              text="Founded in 1982, HO Sports is a powerhouse in the watersports industry producing top-quality waterskis and watersports equipment."
			/>
            <WebscreenSingle
              image="images/hosports-long.jpg"
            />
            <DescriptiveText
              title="Quality Begets Quality"
              text="HO Sports approached Alpine Design with the intention to create a website that accurately portrayed the superior workmanship that goes into all that they do- a sleek, professional site that represents the incomparable products they sell."
            />
            <WebscreenDouble
              image1="images/hosports-side-by-side-1.jpg"
              image2="images/hosports-side-by-side-2.jpg"
            />
            <DescriptiveText
              title="Mobile Product Representation"
              text="HO Sports makes hundreds of watersports products, ranging from high-end waterskis to tubes, life vests, and kneeboards. Alpine Design focused on showcasing the products in a clear and concise manner that worked equally well on mobile and desktop."
            />
            <WebscreenMobile
              image1="images/hosports-mobile-1.png"
              image2="images/hosports-mobile-2.png"
              image3="images/hosports-mobile-3.png"
            />
          </div>
		   <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/hosports.js